/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon, SimpleFlexbox, Text, ModalContainer } from 'ctm-components';
import { getRulesFromState, haveRulesChanged, pageContext } from 'ctm-util-functions';
import styled from 'styled-components';

class _KeyFeaturesList extends Component {

    constructor(props) {
        super(props);
        this.containerVisualProps = { margin: 'right', display: 'flex', itemsCenter: 'xs' };
    }

    /**
     * Don't re-render unless rules have changed
     * @param {Object} nextProps - The incoming set of props
     * @param {Object} nextState - The incoming component state
     * @returns {Boolean} - True if the component should re-render, false otherwise
     */
    shouldComponentUpdate = (nextProps, nextState) => {
        return haveRulesChanged(nextProps, this.props);
    };

    /**
     * Render the KeyFeaturesList if it is visible, otherwise return null
     * @returns {Node|Null} - The KeyFeaturesList if it is visible
     */
    render = () => {
        const { rules } = this.props;
        const visibilityRules = rules?.visibility?.result;
        if (!visibilityRules) {
            return null;
        }

        const {
            stateProps: { product }
        } = this.props;

        const tickIcon = <Icon variant="ctm_tick" color="brand_secondary" size="small" />;
        const crossIcon = <Icon variant="ctm_cross" color="feature_3_120" size="small" />;
        const plusIcon = <Icon variant="ctm_plus" color="blue" size="small" />;

        const features = product.getIn(['productMeta', 'features']);

        const hasLossOfRent = features.getIn(['lossrent', 'value']);
        const hasMaliciousDamage = features.getIn(['malt', 'value']);
        const hasTenantDefault = features.getIn(['rdef', 'value']);

        const getIconAndGroup = (valueFromDb) => {
            let group;
            let icon;
            switch (valueFromDb) {
                case 'Y':
                    group = 'Inclusions';
                    icon = tickIcon;
                    break;
                case 'O':
                    group = 'Optional';
                    icon = plusIcon;
                    break;
                default:
                    group = 'Not available';
                    icon = crossIcon;
            }
            return { group, icon };
        };

        const nonFilteredArray = [
            { id: 1, label: 'Loss of rent', icon: getIconAndGroup(hasLossOfRent).icon, group: getIconAndGroup(hasLossOfRent).group },
            { id: 2, label: 'Malicious damage', icon: getIconAndGroup(hasMaliciousDamage).icon, group: getIconAndGroup(hasMaliciousDamage).group },
            { id: 3, label: 'Tenant default', icon: getIconAndGroup(hasTenantDefault).icon, group: getIconAndGroup(hasTenantDefault).group }
        ];

        /* Isolated CSS */
        const DisclaimerText = styled.span`
            color: #616161;
            font-style: italic;
            font-size: 10px;
            font-weight: 400;
            margin-left: 0.5rem;
        `;

        const IconContainer = styled.span`
            margin-right: 0.3rem; 
            display: flex;
            align-items: center;
        `;

        const Container = styled.div`
            margin-bottom: 0.5rem;
        `;

        const GroupContainer = styled.div`
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        `;

        return (
            <Container>
                <div>
                    <Text tagName="strong">Inclusions</Text>
                    <SimpleFlexbox display="flex" column="xs">
                        {nonFilteredArray.map((item) => {
                            if (item.group === 'Inclusions') {
                                return (
                                    <GroupContainer>
                                        <SimpleFlexbox {...this.containerVisualProps}>
                                            <IconContainer>{item.icon}</IconContainer>
                                            <Text size="small" variant="white_space_nowrap">
                                                &nbsp;
                                                {item.label}
                                            </Text>
                                        </SimpleFlexbox>
                                    </GroupContainer>
                                );
                            }
                        })}
                    </SimpleFlexbox>
                </div>
                {nonFilteredArray.filter((item) => item.group === 'Optional').length !== 0 ? (
                    <div>
                        <Text tagName="strong">
                            Optional inclusions
                            <DisclaimerText>(Select in filter)</DisclaimerText>
                        </Text>
                        <SimpleFlexbox display="flex" column="xs">
                            {nonFilteredArray.map((item) => {
                                if (item.group === 'Optional') {
                                    return (
                                        <GroupContainer>
                                            <SimpleFlexbox {...this.containerVisualProps}>
                                                <IconContainer>{item.icon}</IconContainer>
                                                <Text size="small" variant="white_space_nowrap">
                                                    &nbsp;
                                                    {item.label}
                                                </Text>
                                            </SimpleFlexbox>
                                        </GroupContainer>
                                    );
                                }
                            })}
                        </SimpleFlexbox>
                    </div>
                ) : null}
                {nonFilteredArray.filter((item) => item.group === 'Not available').length !== 0 ? (
                    <div data-id="notAvailable_root">
                        <Text tagName="strong">Not available</Text>
                        <SimpleFlexbox display="flex" column="xs" data-testid="notAvailable_parent">
                            {nonFilteredArray.map((item) => {
                                if (item.group === 'Not available') {
                                    return (
                                        <GroupContainer>
                                            <SimpleFlexbox {...this.containerVisualProps}>
                                                <IconContainer>{item.icon}</IconContainer>
                                                <Text size="small" variant="white_space_nowrap">
                                                    &nbsp;
                                                    {item.label}
                                                </Text>
                                            </SimpleFlexbox>
                                        </GroupContainer>
                                    );
                                }
                            })}
                        </SimpleFlexbox>
                    </div>
                ) : null}
            </Container>
        );
    };

}

_KeyFeaturesList.propTypes = {
    rules: PropTypes.object,
    stateProps: PropTypes.object,
    modalProps: PropTypes.object,
    children: PropTypes.array
};

/**
 * Map the rules to the props
 * @param {Object} state - The application state
 * @param {Object} props - The component props
 * @returns {Object} - The resolved rules object
 */
const mapStateToProps = (state, props) => {
    return props.rules ? { rules: getRulesFromState(state, props) } : props;
};

export const KeyFeaturesList = connect(mapStateToProps)(_KeyFeaturesList);
export { _KeyFeaturesList };
